<template>
  <CommonPay ref="pay" :user="user" :wxpay="wxpay" :probe="probe" :prepay="prepay" title="去水印特权" @paid="afterPaid"/>
</template>

<script>
import api from "../../../../../utils/api";
import CommonPay from "@/comps/CommonPay";

export default {
  name: "WatermarkPrivilege",
  components: {CommonPay},
  props: {
    albumId: String,
    user: Object,
  },
  data() {
    return {
      amount: 39 * 100,
      probeTimeId: null,
      wxArgs: {
        channel: 15,
        app_flag: "efoto.h5.trade.pay",
      }
    }
  },
  methods: {
    open() {
      this.$refs.pay.open(this.amount);
    },
    wxpay() {
      const self = this;
      return api.v1.album.watermark.privilege.create(self.albumId).then(res => {
        return api.v1.album.watermark.privilege.toPay(self.albumId, res.id, self.wxArgs);
      });
    },
    async probe(id) {
      let res = await api.v1.album.watermark.privilege.isPaid(this.albumId, id);
      return res["is_paid"];
    },
    prepay() {
      const self = this;
      return api.v1.album.watermark.privilege.create(self.albumId).then(res => {
        return api.v1.album.watermark.privilege.prepay(self.albumId, res.id);
      });
    },
    afterPaid() {
      window.location.reload(); // 刷新页面
    }
  }
}
</script>

<style scoped>

</style>
